import { render, staticRenderFns } from "./EntityCalendarWidgets.vue?vue&type=template&id=bc4b6ede&scoped=true"
import script from "./EntityCalendarWidgets.vue?vue&type=script&lang=js"
export * from "./EntityCalendarWidgets.vue?vue&type=script&lang=js"
import style0 from "./EntityCalendarWidgets.vue?vue&type=style&index=0&id=bc4b6ede&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4b6ede",
  null
  
)

export default component.exports